var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 5.6C30.4 4.71634 31.1163 4 32 4C32.8836 4 33.6 4.71634 33.6 5.6V12C33.6 12.8837 32.8836 13.6 32 13.6C31.1163 13.6 30.4 12.8837 30.4 12V5.6Z",
    fill: "#1B202C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.9856C14.7582 10.2204 15.0204 9.24183 15.7856 8.8C16.5509 8.35817 17.5294 8.62037 17.9713 9.38564L20.7713 14.2354C21.2131 15.0007 20.9509 15.9792 20.1856 16.421C19.4204 16.8629 18.4418 16.6007 18 15.8354L15.2 10.9856Z",
    fill: "#1B202C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7711 10.9856C49.2129 10.2204 48.9507 9.24183 48.1854 8.8C47.4202 8.35817 46.4416 8.62037 45.9998 9.38564L43.1998 14.2354C42.758 15.0007 43.0202 15.9792 43.7854 16.421C44.5507 16.8629 45.5292 16.6007 45.9711 15.8354L48.7711 10.9856Z",
    fill: "#1B202C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1737 20.8C14.9488 20.8 13.8349 21.4919 13.2998 22.5938C11.1072 27.1094 5.4343 38.8057 4 41.8933V54.4C4 56.1673 5.43269 57.6 7.2 57.6H56.8C58.5673 57.6 60 56.1673 60 54.4V41.8933C58.506 38.6695 52.8812 27.0802 50.7003 22.5925C50.1651 21.4912 49.0517 20.8 47.8272 20.8H16.1737ZM18.2092 27.2L13.6408 36.8H20.8204C21.4281 36.8 21.9832 37.1442 22.2535 37.6884L24.9465 43.1116C25.2168 43.6558 25.7719 44 26.3796 44H37.6204C38.2281 44 38.7832 43.6558 39.0535 43.1116L41.7465 37.6884C42.0168 37.1442 42.5719 36.8 43.1796 36.8H50.3592L45.7908 27.2H18.2092ZM12 49.2C11.1163 49.2 10.4 49.9163 10.4 50.8C10.4 51.6837 11.1163 52.4 12 52.4H52C52.8837 52.4 53.6 51.6837 53.6 50.8C53.6 49.9163 52.8837 49.2 52 49.2H12Z",
    fill: "#1B202C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.51e1bce3893aeabcf237d02636ab8ad2.svg";
export { ForwardRef as ReactComponent };